
import { getSkinnedMeshRenderer } from "@/agents/skinnedMesh/getSkinnedMeshRenderer";

export interface GeneralAgentConfig {
  agentCode: string;
  name: string;
  modelPath: string;
  animationPath: string;
  systemPrompt: string;
  voiceType: string;
  projectName: string;
  cameraNormal: number[];
  cameraZoomed: number[];
  skinnedMesh: any;
}

const generalAgentService = {
  /**
   * Lấy cấu hình Agent cho trang General (Dynamic from API, fallback to default).
   */
  getGlobalConfig: async (): Promise<GeneralAgentConfig> => {
    const agentCode = "general-agent";
    const professionalSystemPrompt = `Bạn là hướng dẫn viên ảo 3D của StarGlobal 3D.
Nhiệm vụ của bạn là hỗ trợ và tư vấn giải pháp cho khách hàng truy cập website starglobal3d.com, giới thiệu các giải pháp công nghệ nổi bật của Starglobal 3D như: chuyển đổi số không gian 3D/360, bản đồ số 3D, tour du lịch thông minh, và các dự án tiêu biểu (Bảo tàng Phụ nữ Nam Bộ, Di tích Dinh Thống Nhất, các khu công nghiệp thông minh...).
Hãy nói chuyện nhẹ nhàng, tự nhiên, tự tin và truyền cảm hứng về công nghệ Việt. Khi người dùng hỏi thăm quan hoặc gợi ý địa điểm, hãy nhiệt tình giới thiệu các giải pháp nổi bật này. TUYỆT ĐỐI TRÁNH lặp lại từ "Vâng, ..." ở đầu mỗi câu trả lời. Hãy trả lời trực tiếp và đa dạng cách mở đầu.`;

    const defaultValues: GeneralAgentConfig = {
      agentCode: agentCode,
      name: "Thúy Kiều",
      modelPath: "/models/model_thuy_kieu_ao_dai_do.glb",
      animationPath: "/models/animation_thuy_kieu_ao_dai_do.glb",
      systemPrompt: professionalSystemPrompt,
      voiceType: "aoede",
      projectName: "Starglobal 3D Global",
      cameraNormal: [0, 1.5, 3.5, 0, 1.0, 0],
      cameraZoomed: [0, 1.5, 1.5, 0, 1.51, 0],
      skinnedMesh: null
    };

    try {
      const response = await fetch(`/api/proxy/v1/general/agent-config/public`);
      if (!response.ok) {
        throw new Error('API response not OK');
      }

      const result = await response.json();
      if (result.success && result.data) {
        const config = result.data;
        
        let modelPath = defaultValues.modelPath;
        let animationPath = defaultValues.animationPath;
        let meshPreset = 'thuykieu';
        let meshConfig = undefined;

        // Trích xuất model/animation được cấu hình tùy chỉnh cho general-agent
        if (config.custom_agent_models && Array.isArray(config.custom_agent_models)) {
          const matched = config.custom_agent_models.find(
            (m: any) => m.code === agentCode
          );
          if (matched) {
            if (matched.modelUrl) modelPath = matched.modelUrl;
            if (matched.animationUrl) animationPath = matched.animationUrl;
            if (matched.meshPreset) meshPreset = matched.meshPreset;
            if (matched.meshConfig) meshConfig = matched.meshConfig;
            if (matched.voice) defaultValues.voiceType = matched.voice;
          }
        }

        return {
          agentCode: agentCode,
          name: config.avatar_name || config.name || defaultValues.name,
          modelPath: modelPath,
          animationPath: animationPath,
          systemPrompt: config.system_prompt || defaultValues.systemPrompt,
          voiceType: config.voice_type || defaultValues.voiceType,
          projectName: defaultValues.projectName,
          cameraNormal: config.camera_normal || defaultValues.cameraNormal,
          cameraZoomed: config.camera_zoomed || defaultValues.cameraZoomed,
          skinnedMesh: getSkinnedMeshRenderer(meshPreset, meshConfig)
        };
      }
    } catch (e) {
      console.error('Failed to fetch general agent config from DB, using fallback defaults', e);
    }

    return {
      ...defaultValues,
      skinnedMesh: getSkinnedMeshRenderer('thuykieu')
    };
  }
};

export default generalAgentService;
